type Props = {
  className?: string;
};

export const FinecoAgentIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="14" fill="#0133cd" />
      <path
        d="M15.10 54.05Q11.10 54.05 7.89 52.64Q4.68 51.23 2.61 48.59Q0.55 45.95 0 42.30L7.10 41.25Q7.85 44.35 10.20 46.03Q12.55 47.70 15.55 47.70Q17.23 47.70 18.80 47.18Q20.38 46.65 21.39 45.63Q22.40 44.60 22.40 43.10Q22.40 42.55 22.24 42.04Q22.08 41.53 21.70 41.08Q21.33 40.63 20.64 40.23Q19.95 39.83 18.90 39.50L9.55 36.75Q8.50 36.45 7.11 35.90Q5.73 35.35 4.43 34.33Q3.13 33.30 2.26 31.61Q1.40 29.93 1.40 27.35Q1.40 23.73 3.23 21.33Q5.05 18.93 8.10 17.75Q11.15 16.58 14.85 16.60Q18.58 16.65 21.50 17.88Q24.43 19.10 26.40 21.44Q28.38 23.78 29.25 27.15L21.90 28.40Q21.50 26.65 20.43 25.45Q19.35 24.25 17.86 23.63Q16.38 23.00 14.75 22.95Q13.15 22.90 11.74 23.39Q10.33 23.88 9.44 24.80Q8.55 25.73 8.55 27.00Q8.55 28.18 9.28 28.91Q10 29.65 11.10 30.10Q12.20 30.55 13.35 30.85L19.60 32.55Q21 32.93 22.70 33.54Q24.40 34.15 25.96 35.24Q27.53 36.33 28.54 38.10Q29.55 39.88 29.55 42.60Q29.55 45.50 28.34 47.66Q27.13 49.83 25.08 51.24Q23.03 52.65 20.44 53.35Q17.85 54.05 15.10 54.05Z"
        fill="#FFFFFF"
        transform="scale(0.4) translate(20, 0)"
      />
    </svg>
  );
};
